
const protocol = window.location.protocol;
const origin = window.location.origin;
const hostname = window.location.hostname;

// Website URL (for frontend routing)
let WEB_URL = origin + '/';

// API Server URL — localhost for dev, production URL for builds
let API_URL = hostname === "localhost" || hostname === "127.0.0.1"
  ? "http://localhost:8084/"
  : "https://api.vyavsay.in/";

global.webUrl = WEB_URL;
global.PATH_FOLDER = "/";

// Web API endpoints (port 8084 via /)
global.API_ADMIN_URL = API_URL + "adminApi/";
global.API_STRIPEAPI_URL = API_URL + "stripeApi/";
global.API_BUSINESS_URL = API_URL + "businessApi/";
global.API_USER_URL = API_URL + "userApi/";
global.API_WEBSITE_URL = API_URL + "webApi/";
global.API_URL = API_URL;
global.LIVE_URL = WEB_URL;  // Static files from website server

global.FLAG_URL = API_URL + "uploadDirectory/flags/flags-small/";
global.BACK_URL = "";
